<template>
  <div class="rec-statistic-m">
    <div class="rec-tab-tit">
      <a
        v-if="recStatisticPermission['inquiry-add']"
        href="javascript:;"
        :class="{active: activeName === 'createSta'}"
        @click="tabChange(1)"
      >{{ $t('message["1772"]') }}</a>
      <a
        v-if="recStatisticPermission['inquiry-audit']"
        href="javascript:;"
        :class="{active: activeName === 'auditSta'}"
        @click="tabChange(2)"
      >{{ $t('message["1773"]') }}</a>
    </div>
    <date-range
      v-if="formateRangeDatasStatus"
      ref="recRef"
      :title="rangeTitTxt"
      range
      type="rec"
      @memberChange="handleCascaderSubmit"
    />
    <date-range
      ref="overviewDateRef"
      :title="overviewTitTxt"
      :date-data="dateData"
      @dateCallback="handleDateChange($event,0)"
    />
    <div class="dev-overview-div">
      <div
        v-for="(item,index) in devRecOverViewDatas"
        :key="index"
        class="dev-normal-content"
      >
        <span class="text">{{ item.name }}</span><span class="number">{{ item.num }}</span>
      </div>
    </div>
    <date-range
      ref="overviewTeamRef"
      :title="dataTitTxt"
      group
      :groupname="defaultTeamName"
      :team-lists="teamLists"
      :date-data="dateData"
      :show-type-select="true"
      @teamSelectFollow="handleTeamSelectFollow"
      @dateCallback="handleDateChange($event,1)"
      @typeCallback="handleTypeChange"
    />
    <div class="dev-data-statistic">
      <div
        class="level-select-div"
        @click="handleLevelSelect"
      >
        <span class="level-select-text">{{ levelText }}</span><i class="iconfont iconicon-test18 level-icon" />
      </div>
      <div
        v-for="(items,indexs) in listDatas"
        :key="indexs"
        class="detail-content"
      >
        <div v-if="dataType===1">
          <div
            v-if="items[0]<=2"
            class="circle"
          >
            {{ items[0] }}
          </div>
          <div
            v-else
            class="circle-gray"
          >
            {{ items[0] }}
          </div>
          <span class="text-content-ellipsis">{{ items[1] }}</span>
          <span class="number">{{ items[2] }}</span>
        </div>
        <div v-else>
          <span class="date-second-data">{{ items[0] }}</span>
          <!-- <span class="date-second-num">{{ items[1] }}</span> -->
          <span class="date-second-number">{{ items[checkIndexs] }}</span>
        </div>
      </div>
      <cube-loading v-if="!listDatas" />
    </div>
    <LevelSelect
      :visible.sync="visible"
      type="rec"
      @levelSelect="handleLevelSelectChange"
    />
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import DateRange from './components/DateSelectComponents'
import { overviewData, formatePickerData } from '@/lib/statistic-utils'
import LevelSelect from './components/LevelSelectComponents'
export default {
  components: {
    DateRange,
    LevelSelect
  },
  data () {
    return {
      activeName: 'createSta',
      foldStatus: false,
      dateData: formatePickerData(overviewData),
      rowDirection: 'iconicon-test17',
      listDatas: [],
      visible: false,
      dataType: null,
      level: null,
      overviewTimeData: { timetype: 5 },
      detailTimeData: { timetype: 5 },
      levelText: this.$t('message["905"]'),
      checkIndexs: null,
      defaultTeamName: '',
      teamLists: []
    }
  },
  computed: {
    ...mapState('statistic', [
      'devRecOverViewDatas',
      'levelList',
      'formateRangeDatasStatus',
      'recTablesDetailDatas',
      'recStatisticPermission',
      'memberRangeDefaultDatas'
    ]),
    rangeTitTxt () {
      return this.$t('message["288"]')
    },
    overviewTitTxt () {
      return this.$t('message["346"]')
    },
    dataTitTxt () {
      return this.$t('message["1130"]')
    }
  },
  watch: {
    recTablesDetailDatas: {
      handler (val) {
        if (!val) return
        if (val.length <= 0) return
        if (val.config[1]) {
          if (val.config[1].options) {
            this.defaultTeamName = val.config[1].name
            const options = val.config[1].options
            const tempv = []
            for (const key in options) {
              tempv.push({ value: key, name: options[key][0] })
            }
            this.teamLists = tempv
          } else {
            this.teamLists = []
            this.defaultTeamName = ''
            if (!this.checkIndexs) {
              this.checkIndexs = 1
            }
          }
        }
        this.listDatas = val.data
        this.dataType = val.type
        document.title = `${this.$t('message["1368"]')}-${this.$store.state.baseinfo.projectname}-${this.$store.state.baseinfo.comname}`
      },
      immediate: true
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    ...mapActions('statistic', ['fetchGetRecOverView', 'fetchGetMemberRecRangeDatas', 'fetchGetRecDetailTableDatas', 'fetchRecStatisticPermission']),
    ...mapMutations('statistic', ['setReceptionType']),
    async init () {
      // 录入统计/审核统计显示权限
      let chain = await this.fetchRecStatisticPermission()
      chain.onSuccess(async res => {
        const { 'inquiry-add': add, 'inquiry-audit': audit } = this.recStatisticPermission || {}
        //  录入+审核权限
        if (add && audit) {
          this.activeName = this.recType || 'createSta'
        } else if (add) { // 录入权限
          this.activeName = 'createSta'
        } else if (audit) { // 审核权限
          this.activeName = 'auditSta'
        }
        // 切换时，修改接口类型
        this.setReceptionType(this.activeName)
        // 请求页面数据
        this.fetchDatas()
      })
    },
    /**
     * clear=1 获取页面数据后，重置选择框默认值，第一次进页面不需要传clear参数，切换菜单时需要clear参数传1
     *  */
    async fetchDatas (clear) {
      let memberChain = await this.fetchGetMemberRecRangeDatas()
      memberChain.onSuccess(() => {
        this.fetchGetRecOverView(this.overviewTimeData)
        this.fetchGetRecDetailTableDatas({ ...this.detailTimeData, page: 1 })

        console.log(this.memberRangeDefaultDatas)
        if (clear === 1) {
          // 重置选择框默认值
          this.$refs.recRef.setMemberText()
          this.$refs.overviewDateRef.defaultDate = this.$refs.overviewDateRef.dateData[0]
          this.$refs.overviewTeamRef.defaultDate = this.$refs.overviewTeamRef.dateData[0]
          this.$refs.overviewTeamRef.typeSelectedText = this.$t('message["907"]')
          this.$refs.overviewTeamRef.teamselectText = this.defaultTeamName
        }
      })
    },
    tabChange (val) {
      const type = val === 1 ? 'createSta' : 'auditSta'
      this.activeName = type
      // 切换时，修改接口类型
      this.setReceptionType(type)
      this.resetDefault(1)
    },
    async resetDefault (clear) {
      // 切换录入统计/审核统计，重置接口数据
      this.overviewTimeData = { timetype: 5 }
      this.detailTimeData = { timetype: 5 }
      this.fetchDatas(clear)
    },
    handleDFold () {
      if (this.rowDirection === 'iconicon-test17') {
        this.foldStatus = true
        this.rowDirection = 'iconicon-test14'
      } else {
        this.foldStatus = false
        this.rowDirection = 'iconicon-test17'
      }
    },
    handleTeamSelectFollow (value) {
      if (!value) return
      this.detailTimeData.groupType = value
      this.fetchGetRecDetailTableDatas({ ...this.detailTimeData, page: 1 })
    },
    handleCascaderSubmit (value) {
      const tempValue = value.value
      let json = {}
      if (Array.isArray(tempValue)) {
        tempValue.map(item => {
          json[item.keyname] = item.id
        })
      }
      delete this.detailTimeData.userid
      delete this.detailTimeData.groupid
      delete this.detailTimeData.roleid
      delete this.overviewTimeData.userid
      delete this.overviewTimeData.groupid
      delete this.overviewTimeData.roleid
      if (tempValue.length === 0) {
        this.fetchGetRecOverView(this.overviewTimeData)
        this.fetchGetRecDetailTableDatas({ ...this.detailTimeData, page: 1 })
      } else {
        this.overviewTimeData = Object.assign(this.overviewTimeData, json)
        this.detailTimeData = Object.assign(this.detailTimeData, json)
        this.fetchGetRecOverView(this.overviewTimeData)
        this.fetchGetRecDetailTableDatas({ ...this.detailTimeData, page: 1 })
      }
    },
    handleLevelSelect () {
      this.visible = true
    },
    handleLevelSelectChange (value) {
      this.levelText = value.name
      if (value.id === -1) {
        this.checkIndexs = 1
        delete this.detailTimeData.level
      } else {
        this.checkIndexs = value.id
        this.detailTimeData.level = value.id
      }
      if (this.dataType === 1) {
        this.fetchGetRecDetailTableDatas({ ...this.detailTimeData, page: 1 })
      }
    },
    handleDateChange (value, flag) {
      if (flag === 0) {
        if (value.value === -1) {
          const { starttime, endtime } = value.time
          delete this.overviewTimeData.timetype
          this.overviewTimeData.starttime = starttime
          this.overviewTimeData.endtime = endtime
        } else {
          delete this.overviewTimeData.starttime
          delete this.overviewTimeData.endtime
          this.overviewTimeData.timetype = value.value
        }
        this.fetchGetRecOverView(this.overviewTimeData)
      } else if (flag === 1) {
        if (value.value === -1) {
          const { starttime, endtime } = value.time
          delete this.detailTimeData.timetype
          this.detailTimeData.starttime = starttime
          this.detailTimeData.endtime = endtime
        } else {
          delete this.detailTimeData.starttime
          delete this.detailTimeData.endtime
          this.detailTimeData.timetype = value.value
        }
        this.fetchGetRecDetailTableDatas({ ...this.detailTimeData, page: 1 })
      }
    },
    handleTypeChange (result) {
      const { value } = result
      if (value === 0) {
        delete this.detailTimeData.info_type
      } else {
        this.detailTimeData.info_type = value
      }
      this.fetchGetRecDetailTableDatas({ ...this.detailTimeData, page: 1 })
    }
  }
}
</script>
<style lang="scss" scoped>
.rec-statistic-m::v-deep {
  .rec-tab-tit {
    height: 48px;
    background: #fff;
    margin-bottom: 12px;
    display: inline-block;
    width: 100%;
    text-align: center;
    border-top: 1px solid #dbdbdb;
    line-height: 48px;
    a {
      display: inline-block;
      margin: 0 10px;
      color: #333;
    }
    .active {
      border-bottom: 2px solid #5077aa;
      color: #5077aa;
    }
  }
  .rec-tab-content {
    border-top: 1px solid #dbdbdb;
  }
}
</style>
